import React, { useEffect, useState } from 'react';

import BackButton from 'components/BackButton';
import {
  Box,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { decryptData } from 'utils/crypto';
import { InfoText, Label, Value, LabelLimit } from './styles';
import { getFormattedDate, getMoney } from 'utils/transform';

import { useTheme } from 'styled-components';
import { IOpcaoPagamento } from 'interfaces/BuscaOpcaoPagamento';
import { IBoleto } from 'interfaces/Boleto';
import { ICustomizacao } from 'interfaces/Customizacao';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const PHONE_MASK = '(99) 99999-9999';

interface IBradescoReorgDividaDetalheProps {
  carteiraId: number;
  crmId: any;
  custom: ICustomizacao;
  navigate: any;
  boleto: IBoleto;
  parcelamento: IOpcaoPagamento;
  whatsapp: string;
  setWhatsapp: any;
  email: string;
  setEmail: any;
  telefone: string;
  setTelefone: any;
  showWhatsApp: boolean;
  loadingBaixarBoleto: boolean;
  loadingEnviarBoleto: boolean;
  onClickBaixarBoleto: any;
  enviarBoletos: any;
  copyToClipboard: any;
  mostraCamposBoletoEmailTelefone: boolean;
}

const BradescoReorgDividaDetalhe = ({
  carteiraId,
  crmId,
  navigate: navigate,
  boleto,
  parcelamento,
}: IBradescoReorgDividaDetalheProps) => {
  const [dividaParcelada, setDividaParecelada] = useState(null);

  useEffect(() => {
    const parcelado = localStorage.getItem('@resumoBoletoParcelamento');

    if (parcelado !== null && parcelado !== undefined) {
      setDividaParecelada(decryptData(parcelado));
    } else {
      setDividaParecelada(null);
    }
  }, []);
  return (
    <div>
      <BackButton
        onClick={() => {
          localStorage.removeItem('@dividaSucesso');
          localStorage.removeItem('@retornoEmitirBoleto');
          navigate('/dashboard');
        }}
      >
        Voltar para Home
      </BackButton>
      <Box mt={2}>
        <Paper
          style={{
            padding: '16px 32px'
          }}
        >
          <Box 
            style={{
              background: '#D9F5D8',
              display: 'flex',
              flexDirection: 'row',
          }}>
            <Box 
              style={{
                color: '#43B369',
                padding: '15px 0 15px 15px'
              }}>
              <CheckCircleIcon  />
            </Box>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: 15
              }}
            >
              <Typography
                style={{color: '#3e3e3e'}}
              >
                <strong>Operação concluída</strong>
              </Typography>
              <InfoText>
                Parabéns, seu acordo foi feito com sucesso!
              </InfoText>
              <InfoText>
                O número da sua reorganização é <strong>{boleto.acordoId}</strong>
              </InfoText>
            </Box>
          </Box>
          <Box mt={3}>
            <Box>
              <LabelLimit style={{marginBottom: 5}}>
                Dados da solicitação
              </LabelLimit>
              <Paper variant="outlined" style={{padding: '15px'}}>
                <Grid container >
                  <Grid item xs={6} sm={4}>
                    <Label>
                      Valor dos contratos selecionados
                    </Label>
                    <Value>
                      {getMoney(parcelamento.valor)}
                    </Value>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <Label>
                      Valor das parcelas
                    </Label>
                    <Value>
                      {getMoney(parcelamento.valorParcela)}
                    </Value>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <Label>
                      IOF total (imposto)
                    </Label>
                    <Value>
                      {getMoney(boleto.valorIof)}
                    </Value>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <Label>
                      Vencimento da primeira parcela
                    </Label>
                    <Value>
                      {getFormattedDate(parcelamento.dataVencimento)}
                    </Value>
                  </Grid>
                </Grid>
              </Paper>
            </Box>      
          </Box>
        </Paper>
      </Box>
    </div>
  );
};

export default BradescoReorgDividaDetalhe;
